import { useEffect } from 'react';

const useStickyObserver = () => {
  useEffect(() => {
    const intersectionObserver = new IntersectionObserver(
      ([entry]) => entry.target.toggleAttribute('data-stuck', entry.intersectionRatio < 1),
      { threshold: [1] }
    );

    const observeElements = () => {
      document.querySelectorAll('[data-observe-sticky]').forEach((el) => {
        intersectionObserver.observe(el);
      });
    };

    const mutationObserver = new MutationObserver(() => {
      observeElements();
    });

    observeElements();
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      intersectionObserver.disconnect();
      mutationObserver.disconnect();
    };
  }, []);
};

export default useStickyObserver;
